export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4 0a1 1 0 011 1v1h6V1a1 1 0 112 0v1h1.222c.404 0 .837.108 1.19.392.373.3.588.743.588 1.233v8.75c0 .49-.215.933-.588 1.233-.354.284-.786.392-1.19.392H1.778c-.404 0-.837-.108-1.19-.392A1.564 1.564 0 010 12.375v-8.75c0-.49.215-.933.587-1.233C.941 2.108 1.374 2 1.777 2H3V1a1 1 0 011-1zm8 4H2v2h12V4h-2zM2 8h12v4H2V8zm-.252-3.998h.002-.002zm0 7.996h.002-.002zm12.504 0h-.002.002zm0-7.996h-.002.002z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "width": "16",
    "height": "16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};